// src/router/permissions.js
export const permissionRouteMap = {
    manage_users: [
        "/users",
        "/approval-setup",
        "/departments",
        "/categories",
    ],
    manage_employees: [
        "/new-employees",
        "/manage-employees",
        "/edit-employee", // Added to match routes.js
    ],
    create_schedule: [
        "/new-schedule",
        "/edit-schedule", // Added to match routes.js
    ],
    approve_schedule: ["/approve-schedules"],
    manage_nominations: [
        "/manage-nominations",
        "/new-nomination", // Added to match routes.js
    ],
    // Public routes (no specific permission required)
    public: [
        "/",
        "/dashboard",
        "/new-recommendation",
        "/recommendations",
        "/edit-recommendation", // Added to match routes.js
        "/manage-schedule",
        "/manage-trainings",
        "/approved-trainings",
        "/trainings-archive",
        "/reports",
        "/login",
        "/register",
        "/forgot-password",
    ],
};

export function getAllowedRoutes(permissions = []) {
    const allowedRoutes = new Set(permissionRouteMap.public);
    permissions.forEach((perm) => {
        if (permissionRouteMap[perm.name]) {
            permissionRouteMap[perm.name].forEach((route) => allowedRoutes.add(route));
        }
    });
    return Array.from(allowedRoutes);
}